export const CAL_TESTIMONIALS = [
  {
    text: `“Skylight Calendar has reduced my son's anxiety so much that he was discharged by his psychologist...it has changed our life."`,
    name: 'Mary M.',
    household: 'Mom of 1,',
    location: 'Perkasie, PA',
  },
  {
    text: `“This has been a game changer! It has allowed our family a one-stop shop for all things calendar and keeps my husband and I on the same page which is huge!”`,
    name: 'Lucy G.',
    household: 'Mom of 2,',
    location: 'Brooklyn, NY',
  },
  {
    text: `“I LOVE that my brain is no longer the long-term storage plan for our family's busy schedule, and my kids have never been so motivated by a chore chart.”`,
    name: 'Emily B.',
    household: 'Mom of 3,',
    location: 'Los Angeles, CA',
  },
  {
    text: `“Skylight has brought clarity and structure to our busy schedules. It's a great communication tool for our whole family to get on the same page.”`,
    name: 'Mark S.',
    household: 'Dad of 2,',
    location: 'Dallas, TX',
  },
  {
    text: `“I love how it takes so much off of my mental load and how easy it is for my kids to use.”`,
    name: 'Krista W.',
    household: 'Mom of 3,',
    location: 'Phoenix, AZ',
  },
]

export const CA_CAL_TESTIMONIALS = [
  {
    text: `“The Skylight Calendar has been a total game-changer for our family of six. With four kids all in different activities, it used to be chaos trying to keep track of everything. Now we can see everyone's schedules in one place, and it's made planning so much easier. The kids even check it themselves and are learning how to plan ahead for their activities, which is a huge win!”`,
    name: 'Jordan',
    household: 'Mom of 4,',
    location: 'Alberta',
  },
  {
    text: `“As a personal in-house chef, the Skylight Calendar has been incredibly helpful for keeping my schedule organized. Between planning meals, prepping, and juggling multiple clients, having everything laid out in one place keeps my days running smoothly. The meal planning feature is a huge bonus — I can map out menus for the week and easily build my grocery list right from there and reference the app while I'm grocery shopping and on the go. This calendar is a must for any small-business owner.”`,
    name: 'Dani',
    household: 'Small Business Owner,',
    location: 'British Columbia',
  },
  {
    text: `“I LOVE that my brain is no longer the long-term storage plan for our family's busy schedule, and my kids have never been so motivated by a chore chart.”`,
    name: 'Emily B.',
    household: 'Mom of 3,',
    location: 'Los Angeles, CA',
  },
  {
    text: `“Skylight Calendar has reduced my son's anxiety so much that he was discharged by his psychologist...it has changed our life."`,
    name: 'Mary M.',
    household: 'Mom of 1,',
    location: 'Perkasie, PA',
  },
  {
    text: `“I love our Skylight Calendar! It's super easy to use and has made organizing our family's schedule so much smoother. Everyone can see what's coming up at a glance, and adding events is quick and simple. Plus, it looks great on the counter — definitely one of our favorite home tech purchases!”`,
    name: 'Mike',
    household: 'Dad of 2,',
    location: 'Ontario',
  },
]

export const FRAME_TESTIMONIALS = [
  {
    text: `"I love how easy the device is to set up, and the packaging was really impressive. The overall look, especially the white frame, is stunning. Plus, the option to switch out the frames is a feature I really appreciate!"`,
    name: 'Alex Mitchell',
  },
  {
    text: `"The frame is sleek and beautifully designed. I got the walnut trim, which blends perfectly with my home décor. It feels solid and well-built, with a good weight that isn't too heavy. The walnut frame is secure but easy to remove if you want to swap styles. I’m really impressed so far!"`,
    name: 'Megal Lawson',
  },
  {
    text: `"The packaging is stylish and very secure. The glass and matte finish give the frame a true picture frame look, making it feel more like a traditional photo display than a tech device."`,
    name: 'David Harris',
  },
  {
    text: `The frame itself has a sleek, modern design, and I really like the width of the black border. Since it's magnetic, I'm excited to explore other color options to match my changing home décor."`,
    name: 'Rachel Morgan',
  },
  {
    text: `"I love the snap-on frame feature! Being able to swap it out to match my décor or personal style as it evolves is a game-changer."`,
    name: 'Emily Stevens',
  },
]

export const BUDDY_TESTIMONIALS = [
  {
    text: `"I have 4 kiddos (age 4-15) and they all love having a Buddy in their room! This helps them a lot because many of their routines are things they do in their room as they get ready for the day or get ready for bedtime! Thanks team Skylight for creating Buddy!"`,
    name: 'Jennifer C.',
    household: 'Mom of 4,',
    location: 'Holly Springs, NC',
  },
  {
    text: `“I didn't expect how much it helps me! If you want your kids to actually follow through on daily routines without turning into a broken record, this is worth every penny. It's simple, effective, and somehow makes responsibility feel like a win instead of a battle."`,
    name: 'Jessica M.',
    household: 'Mom of 3,',
    location: 'Dublin, GA',
  },
  {
    text: `"My 5 and 3 year olds have been using their Buddies for several months and it's been game changing during our morning hustle. They can't read yet, so the emojis make it super easy for them to know what they need to do. And guessing which emoji will rain down after they finish their tasks has become a fun nightly ritual. Also love the visual timer — it's been really hard to get my 5 YO to stay in his room during quiet time and not come out every few mins asking if he's done yet. Now we use the timer and he follows along on his own and we don't have to argue about it (amazing!)."`,
    name: 'Lauren R.',
    household: 'Mom of 2,',
    location: 'San Francisco, CA',
  },
  {
    text: `“Buddy has been a great addition for our son. He chose purple to fit his personality and loves checking off  daily tasks right from his room. It's fun, kid-focused, and helps him stay on track without constant reminders. The nightlight, white noise and alarm clock have also helped him build more independence with his morning/evening routines, especially for early school mornings. The button and fun sound effects also makes it feel more like a game. We love it!”`,
    name: 'Melissa S.',
    household: 'Mom of 1,',
    location: 'Detroit, MI',
  },
  {
    text: `“Buddy has been a fantastic addition to our kids' bedtime and daily routine. Chore completion has noticeably improved, and they actually enjoy checking their progress. It’s become one of those rare devices that's both fun for the kids and genuinely helpful for parents. Highly recommend it for any family trying to build structure without the daily battles.”`,
    name: 'CJ S.',
    household: 'Father of 2,',
    location: 'Houston, TX',
  },
]
